module.exports = __webpack_public_path__ + "media/images/icons/whatsapp-958ba88839ff6fcb5f2f255915d85002.png";